import React, { useEffect,useState, Fragment } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import isAuthenticated from "utils/isAuthenticated";
import * as routes from "utils/contants/urls";
import {
  FormStyle,
  FormGroupStyle,
  LabelFormHeader,
  FormRow,
  LabelBottom,
  RowImage,
  ImageLogin,
  Label,
  InputRow
} from "./FormStyle";
import {
  ButtonDefault,
  TextField,
  ButtonSecondary
} from "../shared/CustomInputs";
import { email } from "../../helpers/validations";
import LogoDefault from "../../assets/images/logo/logo.png";

const renderLoginItens = (loginValues, setLoginValues,submit) => (
  <Fragment>
    <LabelFormHeader>Login</LabelFormHeader>
    <InputRow>
      <TextField
        validate={email}
        onChange={e =>
          setLoginValues({ ...loginValues, email: e.target.value })
        }
        label={<FormattedMessage id="sharedItems.email" />}
        type="email"
        name="email"
        onKeyDown={event => {
          if (event.key === "Enter") {
            submit(loginValues);
          }
        }}
      />
    </InputRow>
    <InputRow>
      <TextField
        label={<FormattedMessage id="login.password" />}
        onChange={e =>
          setLoginValues({ ...loginValues, password: e.target.value })
        }
        type="password"
        name="password"
        onKeyDown={event => {
          if (event.key === "Enter") {
            submit(loginValues);
          }
        }}
      />
    </InputRow>
  </Fragment>
);
const renderForgot = () => (
  <React.Fragment>
    <LabelFormHeader>
      <FormattedMessage id="login.password" />
    </LabelFormHeader>
    <Label>
      <FormattedMessage id="login.disclaimerForgot" />
    </Label>
    <TextField
      validate={email}
      label={<FormattedMessage id="sharedItems.email" />}
      type="email"
      name="email"
    />
  </React.Fragment>
);

const FormLogin = ({ submit }) => {
  const [forgotPassword, setforgotPassword] = useState(false);
  const [loginValues, setLoginValues] = useState({});


  useEffect(() => {
   if (isAuthenticated()){
    window.location.href = `${routes.APP}`;     
   }
  }, []);

  
  return (
    <React.Fragment>
      <RowImage>
        <ImageLogin alt="..." src={LogoDefault} />
      </RowImage>
      <FormStyle>
        <FormGroupStyle>
          {!forgotPassword && renderLoginItens(loginValues, setLoginValues,submit)}


        </FormGroupStyle>
        <FormRow itens={forgotPassword ? 1 : 0}>
          {forgotPassword && (
            <ButtonSecondary
              mr
              onClick={() => setforgotPassword(!forgotPassword)}
              name={<FormattedMessage id="login.back" />}
            />
          )}

          <ButtonDefault
            onClick={() => submit(loginValues)}
            name={
              !forgotPassword ? (
                <FormattedMessage id="login.buttonLogin" />
              ) : (
                <FormattedMessage id="login.reset" />
              )
            }

          />
        </FormRow>
      </FormStyle>
    </React.Fragment>
  );
};
FormLogin.propTypes = {
  submit: PropTypes.func,
  forgotAction: PropTypes.func
};

FormLogin.defaultProps = {
  submit: () => {},
  forgotAction: () => {}
};

export default FormLogin;
